import { MixerHorizontalIcon } from '@radix-ui/react-icons';
import { Table } from '@tanstack/react-table';

import { DropdownMenuTriggerIcon } from '../../patterns/dropdown-menu/dropdown-menu-trigger-icon';
import {
  DropdownMenu,
  DropdownMenuCheckboxItem,
  DropdownMenuContent,
  DropdownMenuGroup,
} from '../dropdown-menu';

interface DataTableVisibilityOptionProps<TData> {
  disabled?: boolean;
  id?: string;
  table: Table<TData>;
}

export function DataTableVisibilityOption<TData>({
  disabled = false,
  id,
  table,
}: DataTableVisibilityOptionProps<TData>) {
  return (
    <DropdownMenu>
      <DropdownMenuTriggerIcon
        id={id ? `${id}-visibilityMenu` : undefined}
        disabled={disabled}
        icon={<MixerHorizontalIcon className="size-4" />}
        variant="outline"
      />
      <DropdownMenuContent className="max-h-80 overflow-y-auto" align="end">
        <DropdownMenuGroup>
          {table
            .getAllColumns()
            .filter((column) => typeof column.accessorFn !== 'undefined' && column.getCanHide())
            .map((column) => {
              return (
                <DropdownMenuCheckboxItem
                  key={column.id}
                  id={id ? `${id}-visibilityMenu-${column.id}` : undefined}
                  className="capitalize"
                  checked={column.getIsVisible()}
                  onCheckedChange={(value) => column.toggleVisibility(!!value)}
                >
                  <span className="px-1">{column.id}</span>
                </DropdownMenuCheckboxItem>
              );
            })}
        </DropdownMenuGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
